<template>
  <div class="p-mb-4">
    <div>{{ __("Remarks") }}:</div>
    <p-vue-textarea
      :autoResize="true"
      rows="4"
      class="p-inputtext--alt"
      v-model="message"
    />
    <div class="p-d-flex p-ai-center" style="gap: 10px;">
      <p-vue-checkbox v-model="showToTennat" :binary="true" />
      <label>{{ __("Show to tenant") }}</label>
    </div>
    <div
      class="p-d-flex p-ai-center p-mt-2"
      style="gap: 10px;"
      v-if="showToTennat"
    >
      <p-vue-checkbox v-model="sendToAllTennat" :binary="true" />
      <label>{{
        __("Send this update to the other tenants of the building as well")
      }}</label>
    </div>
  </div>
  <div class="p-d-flex p-jc-between">
    <p-vue-button
      class="button p-button-rounded p-button-success"
      :label="__('Save')"
      @click="save"
    />
    <p-vue-button
      class="button p-button-rounded p-button-success"
      :label="__('Cancel')"
      @click="close"
    />
  </div>
</template>

<script>
import { dateFormat } from "@/services/apointUtil";
import {
  callProc,
  apiParam,
  apiPType,
  getGlobalApi,
} from "@/services/APointAPI";
import { mapState } from "vuex";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n";
export default {
  props: {
    close: Function,
    PID: Number,
  },
  emits: ["addProblemSub"],
  data() {
    return {
      dateFormat,
      message: "",
      showToTennat: false,
      sendToAllTennat: false,
    };
  },
  mounted() {
    this.getShowUpdateToTennatOnNewSvcCallDefaultValue();
  },
  methods: {
    save() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("Num", null, apiPType.Int),
        apiParam("PID", this.PID, apiPType.Int),
        apiParam("Description", this.message, apiPType.NVarChar),
        apiParam("ShowToTennat", this.showToTennat, apiPType.Bit),
        apiParam("sendToAllTennat", this.sendToAllTennat, apiPType.Bit),
      ];
      callProc("WorkerApp_UpdateOrInsertProblemsSub", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_UpdateOrInsertProblemsSub", result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("The update was saved successfully"));
            setTimeout(() => {
              this.$emit("addProblemSub", result.Table[0]);
            }, 2000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateOrInsertProblemsSub");
        });
    },
    getShowUpdateToTennatOnNewSvcCallDefaultValue() {
      getGlobalApi("showUpdateToTennatOnNewSvcCallDefaultValue")
        .then((result) => {
          this.showToTennat = result != 0;
        })
        .catch(() => {
          errorReceived("showUpdateToTennatOnNewSvcCallDefaultValue");
        });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}
</style>
